/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';

/**
 * person data (without patient folder) of appointment
 * @export
 * @interface PersonAppointment
 */
export interface PersonAppointment {
    /**
     * the unique identifier of person appointment
     * @type {string}
     * @memberof PersonAppointment
     */
    personAppointmentId?: string;
    /**
     * the lastname of person appointment
     * @type {string}
     * @memberof PersonAppointment
     */
    lastname?: string;
    /**
     * the firstname of person appointment
     * @type {string}
     * @memberof PersonAppointment
     */
    firstname?: string;
    /**
     * he email of person appointment
     * @type {string}
     * @memberof PersonAppointment
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof PersonAppointment
     */
    phoneNumber?: PhoneNumber;
}

/**
 * Check if a given object implements the PersonAppointment interface.
 */
export function instanceOfPersonAppointment(value: object): value is PersonAppointment {
    return true;
}

export function PersonAppointmentFromJSON(json: any): PersonAppointment {
    return PersonAppointmentFromJSONTyped(json, false);
}

export function PersonAppointmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonAppointment {
    if (json == null) {
        return json;
    }
    return {
        
        'personAppointmentId': json['personAppointmentId'] == null ? undefined : json['personAppointmentId'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
    };
}

export function PersonAppointmentToJSON(json: any): PersonAppointment {
    return PersonAppointmentToJSONTyped(json, false);
}

export function PersonAppointmentToJSONTyped(value?: PersonAppointment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personAppointmentId': value['personAppointmentId'],
        'lastname': value['lastname'],
        'firstname': value['firstname'],
        'email': value['email'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
    };
}

